import { Box, IconButton, Modal, Typography } from "@mui/material";
import CustomButton from "../../components/custom-button/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "../../components/icon-components/WarningIcon";
import {
  CONFIRMATION,
  CONFIRMATION_MESSAGE,
  CONFIRMATION_NOTE,
} from "../../utility/constants/locale";

interface ConfirmationModalProps {
  modalOpen: boolean;
  onCloseModal: () => void;
  handleSave: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  modalOpen,
  onCloseModal,
  handleSave,
}) => {
 
  return (
    <Modal
      open={modalOpen}
      onClose={onCloseModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "10px",
          p: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            id="modal-title"
            variant="body1"
            fontWeight={"700"}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <WarningIcon
              height={"15px"}
              width={"15px"}
            />
            {CONFIRMATION}
          </Typography>
          <IconButton
            onClick={onCloseModal}
            aria-label="Close"
            sx={{ p: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          id="modal-description"
          variant="body1"
          sx={{ mt: 2, mb: 3 }}
        >
          {CONFIRMATION_MESSAGE}
        </Typography>
        <Typography
          id="modal-description"
          variant="body1"
          sx={{ mt: 2, mb: 3 }}
        >
          {CONFIRMATION_NOTE}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <CustomButton
            variant="outlined"
            text="Cancel"
            onClick={onCloseModal}
          />
          <CustomButton
            variant="contained"
            text="Save"
            onClick={handleSave}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
